import { CONSTANTS } from '@/types/enum/constants'

const getIsUserIndustryStore = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles?.find(value => CONSTANTS.ROLE_DYNAMIC_ROUTE_INDUSTRY_USER_STORE_VENDOR === value) || false

export default getIsUserIndustryStore
